import {LocationData} from "./LocationData";

export const LocationContent = (location: LocationData) => {
    return (
            <div className={'gallery__item s1'}>
                <img src={location.img} alt={location.alt} loading={'lazy'}/>
            </div>
    );
}